var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokActiveA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 8.75,
    fill: "#66CCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5833 21.125C45.1592 19.4992 44.3744 17.4113 44.375 15.25H37.9375V41.0833C37.8878 42.4813 37.2976 43.8055 36.2911 44.777C35.2847 45.7484 33.9405 46.2915 32.5416 46.2917C29.5833 46.2917 27.125 43.875 27.125 40.875C27.125 37.2917 30.5833 34.6042 34.1458 35.7083V29.125C26.9583 28.1667 20.6666 33.75 20.6666 40.875C20.6666 47.8125 26.4166 52.75 32.5208 52.75C39.0625 52.75 44.375 47.4375 44.375 40.875V27.7708C46.9854 29.6455 50.1195 30.6513 53.3333 30.6458V24.2083C53.3333 24.2083 49.4166 24.3958 46.5833 21.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokActiveA);
export default __webpack_public_path__ + "static/media/tiktokActive_a.5447f670ee619f82317d4ce236d47586.svg";
export { ForwardRef as ReactComponent };